import React, { useRef, useState } from 'react';
import { CommonBackContent } from '../Layouts/CommonBackContent';
import dynamic from 'next/dynamic';
import { InsHashTagSearchModel } from '@/types/anonymously.interface';
import { searchInsHashtagListData } from '@/lib/service/anonymously';
import { useUserProvider } from '@/context/UserProvider';
import CommonSimpleModal from '../Common/CommonSimpleModal';
import router from 'next/router';
import { message } from 'antd';

const FAQContent = dynamic(() => import('./FAQContent'), { ssr: true });
const InstagramActivityTrackerContent = dynamic(() => import('./InstagramActivityTracker'), { ssr: true });
const ChooseViewerForInstagramContent = dynamic(() => import('./ChooseViewerForInstagram'), { ssr: true });
const TopSearchContent = dynamic(() => import('./TopSearch'), { ssr: true });
const TopicsListComponent = dynamic(() => import('./TopicsList'), { ssr: true });
const HashtagGeneratorIntroComponent = dynamic(() => import('./hashtag-generator-intro'), { ssr: true });
const HashtagListComponent = dynamic(() => import('./hashtag-list'), { ssr: true });

const HashtagGeneratorContent = ({ data }: { data?: any }) => {
  const [loading, setLoading] = useState(false);
  const { onOpenLoginModal, isLogin, onChangedLoginView } = useUserProvider();
  const [alertInfo, setAlertInfo] = useState<any>(null);
  const [queryListModel, setQueryListModel] = useState<InsHashTagSearchModel[]>([]);
  const [queryName, setQueryName] = useState<string>(null);
  const resultRef = useRef(null);

  const srollToResultView = () => {
    let element = resultRef.current;
    if (element === undefined) {
      return;
    }
    // const yOffset = -50;
    // const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    // window.scrollTo({ top: y, behavior: 'smooth' });
  };

  const onSearchClick = (e?: string) => {
    if (!isLogin) {
      onOpenLoginModal(true);
      onChangedLoginView(false);
      return;
    }

    if (e?.length > 0) {
      if (loading) {
        return;
      }
      setLoading(true);
      if (e !== queryName) {
        setQueryListModel([]);
        setQueryName(e);
      }

      searchInsHashtagListData(e, { isPremium: false, bizFuncName: 'hash_tag' })
        .then((res) => {
          if (res?.code === 0) {
            setQueryListModel(res?.data ?? []);
            srollToResultView();
          } else {
            setQueryListModel([]);
            message.error(res?.message);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <>
      <CommonBackContent
        style={{ maxWidth: '1000px', margin: '0 auto', background: 'transparent', minHeight: '100vh' }}
      >
        <TopSearchContent loading={loading} onSearch={(e) => onSearchClick(e)} />
        <HashtagListComponent hashtags={queryListModel} />
        <InstagramActivityTrackerContent />
        {queryListModel?.length === 0 && <TopicsListComponent dataList={data?.topicsList} />}
        {queryListModel?.length === 0 && <HashtagGeneratorIntroComponent />}
        <ChooseViewerForInstagramContent />
      </CommonBackContent>
      <FAQContent />

      <CommonSimpleModal
        open={alertInfo !== null}
        title={alertInfo?.title}
        desc={alertInfo?.desc}
        btnTitle={alertInfo?.btnTitle}
        closeAction={(isOk) => {
          if (isOk && alertInfo?.href) {
            router.push(alertInfo?.href);
          }
          setAlertInfo(null);
        }}
      />
    </>
  );
};

export default HashtagGeneratorContent;
